export default __webpack_public_path__ + "static/media/luis-bunuel.81bc5aff.jpg";